import type { SVGProps } from 'react';

const AutoClickViewing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 32 32'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M25.977 10.309a.995.995 0 1 0-1.547 1.253c1.507 1.867 2.347 4.08 2.427 6.4.213 5.974-4.48 11.014-10.467 11.213-5.973.214-11.013-4.48-11.213-10.466-.2-5.987 4.48-11.014 10.467-11.214.76-.026 1.56.04 2.426.214.054.013.107 0 .16 0 .134.067.294.106.44.106.227 0 .44-.066.627-.226a1.01 1.01 0 0 0 .16-1.4l-2.64-3.293a.997.997 0 0 0-1.4-.16 1.01 1.01 0 0 0-.16 1.4l1.107 1.373a7.482 7.482 0 0 0-.774-.014C8.51 5.735 2.95 11.71 3.204 18.79c.253 7.08 6.213 12.64 13.293 12.386 7.08-.253 12.64-6.213 12.387-13.293a12.936 12.936 0 0 0-2.907-7.573Z'
      fill='#BCDEFF'
    />
    <path
      d='m11.911 14.273 6.37-2.126c2.861-.953 4.415.608 3.469 3.468l-2.126 6.37c-1.427 4.287-3.772 4.287-5.198 0l-.629-1.892-1.893-.629c-4.28-1.42-4.28-3.757.007-5.19Z'
      fill='#4D9DFF'
    />
    <path
      d='M15.45 18.808a.524.524 0 0 1-.374-.155.533.533 0 0 1 0-.749l2.683-2.698a.533.533 0 0 1 .749 0 .533.533 0 0 1 0 .749l-2.684 2.698a.555.555 0 0 1-.374.155Z'
      fill='#BCDEFF'
    />
  </svg>
);
export default AutoClickViewing;
